import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/journal/[slug]/page.tsx");
